export default __webpack_public_path__ + "media/images/images/banner/banner-16-c661cb71aa143f8500b598d77cd32742.jpg";